import {
    PlateServicesGetPlate,
    PlateServicesGetNotes,
    PlateServicesPutVehicleToken,
} from "@services/PlateServices";
import _, { debounce } from "lodash";
import { checkIfHasBudget } from "@utils/checkIfHasBudget";
import {
    formatPlate,
    getCountryCodeByDataSourceId,
    trimPlate,
    validPlateSize,
    getMask,
    getPlaceholder,
} from "@src/utils/datasource.js";
import { PlateServicesVehicleTree } from "@services/PlateServices";

export default {
    components: {
        DetailsComponent: () =>
            import(
                "@components/shared/widgets/vehicle-identification/DetailsComponent"
            ),
        HistoryComponent: () =>
            import(
                "@components/shared/widgets/vehicle-identification/HistoryComponent"
            ),
        Graphics: () => import("@components/b2b/dashboard/Graphics"),
        SearchByPlateComponent: () =>
            import(
                "@components/shared/widgets/vehicle-identification/SearchByPlateComponent"
            ),
        SearchByMakeComponent: () =>
            import(
                "@components/shared/widgets/vehicle-identification/SearchByMakeComponent"
            ),
    },
    data() {
        return {
            carInfo: {},
            initialSearch: false,
            kTypeFix: "",

            key: 0,
            permissions: [],
            tempVehicleIdentification: {},
            arrayKtypes: [],
            radiosKtypes: "",
            modal: {
                show: false,
                title: "",
                message: "",
            },
            modalKtype: {
                show: false,
                title: this.$t("backoffice.templates.select-option"),
                message: "",
            },
            plate: "",
            showDetails: false,
            modalNotes: {
                show: false,
                title: "",
                message: "",
                notes: "",
            },
            carNotPlate: null,
            modalAlertToLeave: {
                mode: 0,
                show: false,
                needToRedirect: false,
                temporaryCard: null,
                hideMessage: false,
                plate: null,
                dataSourceId: null,
            },
            countriesPlate: [
                { text: "P", value: 1 },
                { text: "F", value: 2 },
            ],
            countrySelected: "1",
            isPhotoDefault: true,
            tabs: 0,

            manualPlateValue: "",
            comboBoxmakeValue: "",
            comboBoxmodelValue: "",
            comboBoxbodyworkValue: "",
            comboBoxfuelValue: "",
            comboBoxversionValue: "",
            kTypeValue: "",
            btnSearch: true,

            comboBoxes: {
                make: {
                    items: [],
                    disable: true,
                    loading: false,
                },
                model: {
                    items: [],
                    disable: true,
                    loading: false,
                },
                bodywork: {
                    items: [],
                    disable: true,
                    loading: false,
                },
                fuel: {
                    items: [],
                    disable: true,
                    loading: false,
                },
                version: {
                    items: [],
                    disable: true,
                    loading: false,
                },
            },
        };
    },
    computed: {
        computedVehicle() {
            return this.$store.getters["vehicleIdentification/getState"]
                .processNumber;
        },
        changedVehicleIdentification() {
            return this.$store.getters[
                "vehicleIdentification/getChangedVehicleIdentification"
            ];
        },
        photoVehicle() {
            this.isPhotoDefault = true;
            let imageVehicle =
                this.$store.getters["vehicleIdentification/getState"]
                    .vehiclePhotoDefault;

            if (
                this.$store.getters["vehicleIdentification/getState"]
                    .vehiclePhoto != "Image Not Found" &&
                this.$store.getters["vehicleIdentification/getState"]
                    .vehiclePhoto != undefined &&
                this.$store.getters["vehicleIdentification/getState"]
                    .vehiclePhoto != null
            ) {
                this.isPhotoDefault = false;
                imageVehicle =
                    "data:image/png;base64," +
                    this.$store.getters["vehicleIdentification/getState"]
                        .vehiclePhoto;
            }

            return imageVehicle;
        },
        vehicleInformation() {
            return this.$store.getters["vehicleIdentification/controlDetails"];
        },
        carNotes() {
            return this.$store.getters[
                "vehicleIdentification/getVehicleIdentificationNotes"
            ];
        },
        B2bAuth() {
            return this.$store.getters["auth/getState"].isB2B;
        },
        checkPlate() {
            return this.$store.getters["vehicleIdentification/getState"]
                .plateNumber;
        },
    },
    watch: {
        countrySelected() {
            this.$store.commit(
                "vehicleIdentification/setVehicleIdentificationDataSourceId",
                this.countrySelected
            );
        },
        showClear() {
            this.key++;
        },
        initPlate: {
            handler: function(newValue) {
               if (newValue) {
                this.plate = newValue;
            }
            },
            immediate: true,
            deep: true,
        },
        initCountry(newValue) {
            if (newValue) {
                this.countrySelected = newValue;
            }
        },
        changedVehicleIdentification() {
            if (this.computedVehicle) {
                let state =
                    this.$store.getters["vehicleIdentification/getState"];
                if (!this.strema) {
                    this.plate = state.plateNumber;
                }
                this.countrySelected = state.dataSourceId;
                this.key++;
            }
        },
        checkPlate: {
            handler: function () {
                if (
                    this.$store.getters["vehicleIdentification/getState"]
                        .dataSourceId
                ) {
                    this.countrySelected = String(
                        this.$store.getters["vehicleIdentification/getState"]
                            .dataSourceId
                    );
                }
            },
            immediate: true,
            deep: true,
        },
        computedVehicle: {
            handler: debounce(function (newValue) {
                if (this.shouldGetNotes(newValue)) {
                    this.getCarNotes(newValue);
                }
            }, 100),
        },
    },
    methods: {
        isVehicleAlreadyLoaded() {
            //console.log("isVehicleLoaded");

            let loadedVehicle =
                this.$store.getters["vehicleIdentification/getState"];
            if (loadedVehicle.processNumber) {
                if (loadedVehicle.plateNumber) {
                    return (
                        trimPlate(this.carInfo.plate).toLowerCase() ==
                        trimPlate(loadedVehicle.plateNumber).toLowerCase()
                    );
                } else {
                    let make = loadedVehicle.data.find(
                        (o) => o.attribID == this.$globals.ATTRIB_ID.MAKE
                    ).value;
                    let model = loadedVehicle.data.find(
                        (o) => o.attribID == this.$globals.ATTRIB_ID.MODEL
                    ).value;
                    let bodyGroup = loadedVehicle.data.find(
                        (o) => o.attribID == this.$globals.ATTRIB_ID.BODY_GROUP
                    ).value;
                    let fuelType = loadedVehicle.data.find(
                        (o) => o.attribID == this.$globals.ATTRIB_ID.FUEL_TYPE
                    ).value;
                    let version = loadedVehicle.data.find(
                        (o) => o.attribID == this.$globals.ATTRIB_ID.VERSION
                    ).value;
                    let kType = loadedVehicle.data.find(
                        (o) => o.attribID == this.$globals.ATTRIB_ID.VEHICLE_ID
                    ).value;

                    return (
                        loadedVehicle.manualPlate == this.carInfo.manualPlate &&
                        make == this.carInfo.make &&
                        model == this.carInfo.model &&
                        bodyGroup == this.carInfo.bodyGroup &&
                        fuelType == this.carInfo.fuelType &&
                        version == this.carInfo.version &&
                        kType == this.carInfo.kType
                    );
                }
            }
            return false;
        },
        async loadVehicle(info, initial = true) {
            //console.log("loadVehicle");

            this.carInfo = info;
            this.searchVehicle(null, initial);
        },
        searchVehicle(params, initial = false) {
            //console.log("searchVehicle");

            this.initialSearch = initial;
            this.closeModal();

            if (params) {
                this.carInfo = {};
                if (params.plate && params.dataSourceId) {
                    this.carInfo.plate = params.plate;
                    this.carInfo.dataSourceId = params.dataSourceId;
                }
            }

            if (!this.isVehicleAlreadyLoaded() || this.strema) {
                this.plate = this.carInfo.plate;
                this.countrySelected = this.carInfo.dataSourceId;

                if (!this.initialSearch) {
                    let show = this.showQuotationModal(1, this.carInfo);
                    if (show) return;
                }

                let result = this.validateSizePlateString(
                    this.carInfo.plate,
                    this.carInfo.dataSourceId
                );

                if (result) {
                    this.resolvePlate(this.carInfo.plate);
                } else {
                    this.resolveNoPlate();
                }
            }
        },
        resolvePlate(plate) {
            //console.log("resolveplate");

            if (!this.strema) {
                this.$store.commit("loadings/setStateLoadingSideBar", true);
            } else {
                this.$store.commit("loadings/setStateLoadingTemplate", true);
            }

            let countryCode = getCountryCodeByDataSourceId(
                this.countrySelected
            );

            let payLoad = {
                Username: this.$store.getters["auth/getState"].userName,
                IdentificationKey:
                    this.$store.getters["auth/getState"].vrmSubscriptionKey,
                CountryCode: countryCode,
                LanguageCode: this.$store.getters["auth/getState"].languageCode,
                PlateNumber: plate,
            };

            PlateServicesGetPlate(payLoad)
                .then((response) => {
                    // if (!this.strema && !callback) {
                    //     localStorage.removeItem("@copyShoppingCart");
                    //     const shoppingCartCopy = {
                    //         operations: [],
                    //         parts: [],
                    //     };
                    //     this.$store.commit(
                    //         "budget/setShoppingCartCopy",
                    //         shoppingCartCopy
                    //     );
                    // }

                    let vehicleIdentification = {
                        typeSearch: "searchByPlate",
                        plateNumber: plate,
                        data: response.data.result.vehicleIdentification,
                        processNumber: response.data.result.processNumber,
                        vehiclePhoto: this.loadVehiclePhoto(response),
                        token: response.data.result.token,
                        dataSourceId: this.countrySelected,
                    };

                    this.tempVehicleIdentification = vehicleIdentification;
                    this.tempVehicleIdentification.dataAdicional =
                        response.data.result.additionalVehicleIdentification;

                    const isOneKeyType = this.isOneKtype();

                    if (isOneKeyType && !this.strema) {
                        this.$store.commit(
                            "vehicleIdentification/setVehicleIdentification",
                            vehicleIdentification
                        );

                        this.$emit(
                            "handlePlate",
                            vehicleIdentification.plateNumber,
                            vehicleIdentification.data.find(
                                (o) =>
                                    o.attribID == this.$globals.ATTRIB_ID.MAKE
                            ).value,
                            vehicleIdentification.data.find(
                                (o) =>
                                    o.attribID == this.$globals.ATTRIB_ID.MODEL
                            ).value,
                            !vehicleIdentification
                        );

                        if (
                            this.$store.getters["auth/getState"].isB2B &&
                            !this.initialSearch
                        ) {
                            this.$store.commit(
                                "budget/setB2bClearShoppingCart"
                            );
                            this.$store.commit("budget/setB2bCurrentStep", 1);
                            localStorage.removeItem("budgetB2b");
                            if (
                                this.$route.name !== "dashboard" &&
                                this.$route.name === "active-reception"
                            ) {
                                this.$router.push({
                                    name: "active-reception-services",
                                });
                            }
                            this.$store.commit(
                                "budget/setClearBudgetSummary",
                                {}
                            );
                            const payloadBudgetStartedBy = {
                                budgetId: null,
                                budgetName: "",
                            };
                            this.$store.commit(
                                "budget/setBudgetStartedBy",
                                payloadBudgetStartedBy
                            );
                        }

                        this.$store.commit(
                            "loadings/setStateLoadingSideBar",
                            false
                        );

                        this.verifyRouteName();
                    } else if (isOneKeyType) {
                        this.$store.commit(
                            "loadings/setStateLoadingTemplate",
                            false
                        );
                        this.$emit(
                            "on-plate-search",
                            this.tempVehicleIdentification
                        );
                    } else {
                        this.$store.commit(
                            "loadings/setStateLoadingTemplate",
                            false
                        );
                        if (this.carInfo.kType) {
                            this.clickModalKtype(this.carInfo.kType);
                        } else {
                            this.radiosKtypes = "";
                            if (response.data.result.suggestedVehicleId) {
                                this.radiosKtypes =
                                    response.data.result.suggestedVehicleId;
                            }
                            this.showKtypes();
                        }
                    }
                })
                .catch((error) => {
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );
                    if (!this.strema) {
                        this.modal.title = this.$t("alert");
                        if (
                            error.response.data.errorCode == "VehicleNotFound"
                        ) {
                            this.modal.message = this.$t(
                                "backoffice.mytips.modal-request.message"
                            );
                        } else {
                            this.modal.message =
                                error.response.data.errorMessage;
                        }
                        this.modal.show = true;

                        this.clearVehicleIdentification();

                        this.$store.commit(
                            "loadings/setStateLoadingSideBar",
                            false
                        );

                        this.$router.push("/dashboard");
                    } else {
                        this.$store.commit(
                            "loadings/setStateLoadingTemplate",
                            false
                        );
                        this.$emit("on-input-changed", false);
                    }
                })
                .finally(() => {
                    if (!this.strema) {
                        localStorage.removeItem("@datadrive:planning-event");
                        this.$store.commit("planning/setPlanningEvent", {});
                        this.$store.commit("planning/setClearPlanning", {});
                        this.$store.commit(
                            "loadings/setStateLoadingSideBar",
                            false
                        );
                    }

                    if (this.$route.name == "active-reception-services") {
                        location.reload();
                    }

                    let currentBudgetProcessNumber =
                        this.$store.getters["budget/getStateB2b"]
                            .currentProcessNumberByCar;
                    if (
                        this.isBudget() &&
                        currentBudgetProcessNumber !=
                            this.tempVehicleIdentification.processNumber &&
                        !this.initialSearch
                    ) {
                        this.initialSearch = false;
                        this.$router.push("/dashboard");
                    }
                });
        },
        async resolveNoPlate() {
            //console.log("resolvenoplate");

            if (this.strema) return;

            if (this.carInfo.make) {
                //console.log("hasmake");

                this.searchInServices(null, null, true);
            } else {
                //console.log("hasnomake");

                this.modal.title = this.$t(
                    "backoffice.templates.messages.vehicle-not-found-plate"
                );
                this.modal.message = this.$t(
                    "backoffice.templates.messages.search-vehicle"
                );
                this.modal.show = true;
                this.clearPlate();
            }
        },
        closeModalAlertToLeave(maintain = true) {
            if (maintain) {
                this.updatePlateCountry(
                    this.modalAlertToLeave.oldPlate,
                    this.modalAlertToLeave.oldDataSourceId
                );
            }

            this.modalAlertToLeave.show = false;
        },
        searchByModelBrand() {
            this.$emit("search-model-brand", true);
        },
        searchByModelClicked() {
            this.tabs = 1;
        },
        routeRequiresVehicleLoaded() {
            return (
                window.location.href.includes("active-reception/") ||
                window.location.href.includes("tech-info")
            );
        },
        closeModal(triggeredManually = false) {
            this.tabs = 0;
            this.$emit("modal-closed");
            if (
                !this.computedVehicle &&
                this.routeRequiresVehicleLoaded() &&
                triggeredManually
            ) {
                this.$router.push("/dashboard");
            }
        },
        onPlateChanged(plate) {
            this.plate = plate;
            this.$emit("on-input-changed", plate);
        },
        getValidNotes() {
            return this.carNotes && this.carNotes.hasNotes
                ? this.carNotes.notes.filter((o) => o.isValid)
                : [];
        },
        getAllNotes() {
            return this.carNotes && this.carNotes.hasNotes
                ? this.carNotes.notes
                : [];
        },
        clickOutside(value) {
            this.modalNotes.show = value;
        },
        getMaskByDataSourceId(dataSourceId) {
            return getMask(dataSourceId);
        },
        getPlaceholderByDataSourceId(dataSourceId) {
            return getPlaceholder(dataSourceId);
        },
        checkPermissions() {
            return this.permissions.some((e) => e.underSubModuleId == 7);
        },
        async clearShoppingCart() {
            this.$store.commit("loadings/setStateLoadingTemplate", true);
            let processNummber =
                this.$store.getters["vehicleIdentification/getState"]
                    .processNumber;
            this.$store.commit("budget/setB2bClearShoppingCart");
            this.$store.commit("budget/setB2bCurrentStep", 1);
            localStorage.removeItem("budgetB2b");
            await this.$nextTick();
            const shoppingCartCopy = {
                operations: [],
                parts: [],
            };
            const payloadBudgetStartedBy = {
                budgetId: null,
                budgetName: "",
            };
            const shoppingCartTotals = {
                operations: { totals: {} },
                parts: { totals: {} },
            };
            this.$store.commit(
                "budget/setBudgetStartedBy",
                payloadBudgetStartedBy
            );
            this.$store.commit("budget/setShoppingCartCopy", shoppingCartCopy);
            this.$store.commit(
                "budget/setShoppingCartTotalsClear",
                shoppingCartTotals
            );
            localStorage.removeItem("@copyShoppingCart");
            localStorage.removeItem("@shoppingCartTotals");
            this.$store.commit(
                "budget/setCurrentProcessNumberByCar",
                processNummber
            );
            this.$store.commit("budget/setClearBudgetSummary", {});
            this.$store.commit("loadings/setStateLoadingTemplate", false);
        },
        async onDontSaveBudget() {
            //console.log("ondontsave");

            this.closeModalAlertToLeave(false);
            this.clearPlate();

            // mode == 1 - normal search
            // mode == 2 - country changed
            // mode == 3 - clear plate (no need special, case, plate is always cleared)
            if (this.modalAlertToLeave.mode == 1) {
                this.loadVehicle(this.modalAlertToLeave.newCarInfo, true);
            } else if (this.modalAlertToLeave.mode == 2) {
                this.countrySelected =
                    this.modalAlertToLeave.newCarInfo.dataSourceId;
            }
        },
        onSaveBudget() {
            //console.log("onsave");

            this.closeModalAlertToLeave();

            this.plate =
                this.$store.getters[
                    "vehicleIdentification/getState"
                ].plateNumber;
            if (!this.isBudget()) {
                this.$router.push({ name: "budget-summary" });
            }
        },
        clickModalCancel() {
            this.modalKtype.show = false;
            this.updatePlateCountry();
        },
        clickModalKtype(kType) {
            this.$store.commit("loadings/setStateLoadingSideBar", false);
            this.modalKtype.show = false;

            let body = {
                token: this.tempVehicleIdentification.token,
                vehicleId: kType ? kType : this.radiosKtypes,
                languageCode: this.$store.getters["auth/getState"].languageCode,
            };

            PlateServicesPutVehicleToken(body)
                .then((response) => {
                    this.tempVehicleIdentification.token =
                        response.data.result.token;
                    this.tempVehicleIdentification.data =
                        response.data.result.vehicleIdentification;
                    this.tempVehicleIdentification.processNumber =
                        response.data.result.processNumber;
                    if (!this.strema) {
                        this.$store.commit(
                            "vehicleIdentification/setVehicleIdentification",
                            this.tempVehicleIdentification
                        );

                        this.$emit(
                            "handlePlate",
                            this.tempVehicleIdentification.plateNumber,
                            this.tempVehicleIdentification.data.find(
                                (o) =>
                                    o.attribID == this.$globals.ATTRIB_ID.MAKE
                            ).value,
                            this.tempVehicleIdentification.data.find(
                                (o) =>
                                    o.attribID == this.$globals.ATTRIB_ID.MODEL
                            ).value,
                            !this.tempVehicleIdentification
                        );
                    } else {
                        this.$store.commit(
                            "loadings/setStateLoadingTemplate",
                            false
                        );
                        this.$emit(
                            "on-plate-search",
                            this.tempVehicleIdentification
                        );
                    }

                    this.verifyRouteName();
                })
                .catch((error) => {
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );
                    this.modal.title = this.$t(
                        "backoffice.templates.messages.vehicle-not-found-type"
                    );
                    this.modal.message = this.$t(
                        "backoffice.templates.messages.contact-admin"
                    );
                    this.modal.show = true;

                    this.clearVehicleIdentification();

                    this.$router.push("/dashboard");
                })
                .finally(() => {
                    this.$store.commit("budget/setB2bClearShoppingCart");
                    this.$store.commit("budget/setB2bCurrentStep", 1);
                    const payloadBudgetStartedBy = {
                        budgetId: null,
                        budgetName: "",
                    };
                    this.$store.commit(
                        "budget/setBudgetStartedBy",
                        payloadBudgetStartedBy
                    );
                });
        },
        async clearPlate() {
            this.plate = "";
            this.key++;

            if (!this.strema) {
                await this.clearShoppingCart();

                this.clearVehicleIdentification();

                this.$emit("handlePlate");
                if (
                    this.isBudget() ||
                    this.$route.name == "budget_nextRevision"
                ) {
                    this.$router.push("/dashboard");
                }
            } else {
                this.$emit("on-plate-cleared");
            }

            return;
        },
        isBudget() {
            return (
                this.$route.name == "budget-summary" ||
                this.$route.name == "budget-summary-edit"
            );
        },
        searchInServices(comboBox, newValue, resolveTree = false) {
            //console.log("searchinservices");

            let payload;

            if (resolveTree) {
                this.$store.commit("loadings/setStateLoadingSideBar", true);
                payload = {
                    processNumber: "",
                    countryCode:
                        this.$store.getters["auth/getState"].countryCode,
                    languageCode:
                        this.$store.getters["auth/getState"].languageCode,
                    make: this.carInfo.make,
                    model: this.carInfo.model,
                    bodyGroup: this.carInfo.bodyGroup,
                    fuelType: this.carInfo.fuelType,
                    version: this.carInfo.version,
                    accessTipology: 1,
                    kType: this.carInfo.kType,
                    manualPlate: trimPlate(this.carInfo.manualPlate),
                };
            } else {
                if (comboBox && comboBox !== "final") {
                    this.comboBoxes[comboBox].loading = true;
                } else {
                    let show = this.showQuotationModal(1, {
                        make: this.comboBoxmakeValue,
                        model: this.comboBoxmodelValue,
                        bodyGroup: this.comboBoxbodyworkValue,
                        fuelType: this.comboBoxfuelValue,
                        version: this.comboBoxversionValue,
                        manualPlate: this.manualPlateValue,
                    });
                    if (show) return;
                }

                this.$store.commit("loadings/setStateLoadingTemplate", true);
                payload = {
                    processNumber: "",
                    countryCode: getCountryCodeByDataSourceId(
                        this.countrySelected
                    ),
                    languageCode:
                        this.$store.getters["auth/getState"].languageCode,
                    make:
                        comboBox == "model" ? newValue : this.comboBoxmakeValue,
                    model:
                        comboBox == "bodywork"
                            ? newValue
                            : this.comboBoxmodelValue,
                    bodyGroup:
                        comboBox == "fuel"
                            ? newValue
                            : this.comboBoxbodyworkValue,
                    fuelType:
                        comboBox == "version"
                            ? newValue
                            : this.comboBoxfuelValue,
                    version: this.comboBoxversionValue,
                    accessTipology: 1,
                    manualPlate: this.manualPlateValue,
                };
            }
            return PlateServicesVehicleTree(payload)
                .then((response) => {
                    if (comboBox && comboBox !== "final") {
                        this.comboBoxes[comboBox].loading = false;
                        this.comboBoxes[comboBox].disable = false;
                        this.comboBoxes[comboBox].items = [];
                        response.data.result.vehicleIdentification.forEach(
                            (item, index) => {
                                this.comboBoxes[comboBox].items.push(
                                    item.value
                                );
                            }
                        );
                        if (
                            response.data.result.vehicleIdentification.length ==
                            1
                        ) {
                            this[`comboBox${comboBox}Value`] =
                                response.data.result.vehicleIdentification[0].value;
                        }

                        if (comboBox == "model" && this.model) {
                            this.comboBoxmodelValue = this.model;
                        }
                        if (comboBox == "make" && this.make) {
                            this.comboBoxmakeValue = this.make;
                        }
                        if (comboBox == "bodywork" && this.bodyGroup) {
                            this.comboBoxbodyworkValue = this.bodyGroup;
                        }
                        if (comboBox == "fuel" && this.fuelType) {
                            this.comboBoxfuelValue = this.fuelType;
                        }
                        if (comboBox == "version" && this.version) {
                            this.comboBoxversionValue = this.version;
                        }
                    } else {
                        this.$emit("vehicle-searched");
                        let vehicleIdentification = {
                            typeSearch: "searchByManual",
                            plateNumber: "",
                            data: response.data.result.vehicleIdentification,
                            processNumber: response.data.result.processNumber,
                            vehiclePhoto: this.loadVehiclePhoto(response),
                            token: response.data.result.token,
                            manualPlate: resolveTree
                                ? this.carInfo.manualPlate
                                : this.manualPlateValue,
                        };
                        this.plate = "";

                        this.$store.commit(
                            "vehicleIdentification/setVehicleIdentification",
                            vehicleIdentification
                        );

                        if (this.redirectAfterSearch) {
                            this.$router.push("/dashboard");
                        }
                    }

                    if (resolveTree) {
                        let currentBudgetProcessNumber =
                            this.$store.getters["budget/getStateB2b"]
                                .currentProcessNumberByCar;
                        if (
                            this.isBudget() &&
                            currentBudgetProcessNumber !=
                                vehicleIdentification.processNumber &&
                            !this.initialSearch
                        ) {
                            this.initialSearch = false;
                            this.$router.push("/dashboard");
                        }
                    } else {
                        let kType = "";
                        if (response.data.result.vehicleIdentification) {
                            let findKtype =
                                response.data.result.vehicleIdentification.filter(
                                    (item) => item.description == "VehicleId"
                                );
                            if (findKtype && findKtype.length > 0) {
                                if (
                                    findKtype[0].value !== "" &&
                                    findKtype[0].value !== null &&
                                    findKtype[0].value !== undefined
                                ) {
                                    kType = findKtype[0].value;
                                }
                            }
                        }
                        if (kType !== "") {
                            this.kTypeFix = kType;
                        } else {
                            kType = this.kTypeFix;
                        }
                        if (
                            this.comboBoxmakeValue &&
                            this.comboBoxmodelValue &&
                            this.comboBoxbodyworkValue &&
                            this.comboBoxfuelValue &&
                            this.comboBoxversionValue &&
                            this.kTypeFix
                        ) {
                            this.$emit(
                                "handlePlateByModel",
                                this.comboBoxmakeValue,
                                this.comboBoxmodelValue,
                                this.comboBoxbodyworkValue,
                                this.comboBoxfuelValue,
                                this.comboBoxversionValue,
                                this.kTypeFix
                            );
                        }
                    }
                })
                .catch((error) => {
                    this.comboBoxes[comboBox].loading = false;
                    this.comboBoxes[comboBox].disable = false;
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );

                    console.error(error);

                    this.clearVehicleIdentification();
                })
                .finally(() => {
                    if (resolveTree) {
                        this.$store.commit(
                            "loadings/setStateLoadingSideBar",
                            false
                        );
                    } else {
                        this.$store.commit(
                            "loadings/setStateLoadingTemplate",
                            false
                        );
                    }
                });
        },
        isOneKtype() {
            if (
                this.tempVehicleIdentification &&
                this.tempVehicleIdentification.dataAdicional
            ) {
                return this.tempVehicleIdentification.dataAdicional.length <= 1;
            }
            return false;
        },
        showKtypes() {
            this.arrayKtypes = [];

            let data = this.tempVehicleIdentification.dataAdicional;

            for (var [key, value] of Object.entries(data)) {
                let item = {
                    Ktype: "",
                    Make: "",
                    Model: "",
                    Version: "",
                    Build_From: "",
                    Build_To: "",
                    Power_CV: "",
                    Drive: "",
                };
                for (var [key2, value2] of Object.entries(
                    value.additionalInfo
                )) {
                    if (value2.description == "VehicleId") {
                        item.Ktype = value2.value;
                    } else {
                        item[value2.description] = value2.value;
                    }
                }
                this.arrayKtypes.push(item);
            }

            this.modalKtype.show = true;
        },
        validateSizePlateString(plate, dataSourceId) {
            //console.log("validatesize");

            if (plate && dataSourceId) {
                return validPlateSize(
                    dataSourceId,
                    formatPlate(dataSourceId, plate)
                );
            }
            return false;
        },
        updatePlateCountry(
            plate = null,
            country = null,
            countryChanged = false
        ) {
            //console.log("updatecountryplate");

            let state = this.$store.getters["vehicleIdentification/getState"];
            let dataSources = this.$store.getters["auth/getState"].dataSources;

            this.countrySelected =
                country ||
                this.carInfo.dataSourceId ||
                state.dataSourceId ||
                (dataSources && dataSources.length > 0
                    ? dataSources[0].value
                    : "1");

            if (countryChanged || state.typeSearch == "searchByManual") {
                this.plate = "";
            } else {
                let p = plate || this.carInfo.plate || state.plateNumber;
                this.plate = formatPlate(this.countrySelected, p);
            }
            this.key++;
        },
        shouldGetNotes(processNumber) {
            let carNotes =
                this.$store.getters[
                    "vehicleIdentification/getVehicleIdentificationNotes"
                ];
            return (
                processNumber &&
                (!carNotes || carNotes.processNumber != processNumber) &&
                this.$helpers.isModuleActive(
                    this.$globals.MODULES.TECHNICAL_INFORMATION.ID
                ) &&
                this.$store.getters["auth/getState"].isB2B
            );
        },
        getCarNotes(processNumber) {
            const emptyPayload = {
                processNumber: null,
                notes: [],
                hasNotes: false,
                hasValidNotes: false,
            };
            return PlateServicesGetNotes()
                .then((response) => {
                    if (
                        response.data.result &&
                        response.data?.result?.length !== 0
                    ) {
                        this.handleWithNotes(
                            response.data.result,
                            processNumber
                        );
                    } else {
                        this.$store.commit(
                            "vehicleIdentification/setVehicleIdentificationNotes",
                            emptyPayload
                        );
                    }
                })
                .catch((error) => {
                    this.$store.commit(
                        "vehicleIdentification/setVehicleIdentificationNotes",
                        emptyPayload
                    );
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );
                });
        },
        onSeeNotesClicked() {
            this.modalNotes.show = false;
            this.$router.push({ name: "vehicle-alerts" });
        },
        onClickVehicleSearchRouterLink() {
            const item = {
                name: "Vehicle Search",
                routeSidebar: "/vehicle/search",
            };
            this.$store.commit(
                "sidebarActiveMenu/setSidebarActiveMenuState",
                item
            );
        },
        showQuotationModal(mode, carInfo) {
            //console.log("showquotationmodal");

            if (this.strema) return false;

            const budgetExists = checkIfHasBudget();
            if (budgetExists) {
                //console.log("budgetexists");

                let state =
                    this.$store.getters["vehicleIdentification/getState"];

                this.modalAlertToLeave.oldPlate = state.plateNumber;
                this.modalAlertToLeave.oldDataSourceId = state.dataSourceId;

                this.modalAlertToLeave.newCarInfo = carInfo;

                this.modalAlertToLeave.mode = mode;
                this.modalAlertToLeave.show = true;
                this.key++;

                if (carInfo && carInfo.dataSourceId) {
                    this.countrySelected = carInfo.dataSourceId;
                }
                return true;
            }
            return false;
        },
        onCountryChanged(country) {
            if (typeof country !== "string") return;

            let show = this.showQuotationModal(2, {
                dataSourceId: country,
            });
            if (show) return;

            this.updatePlateCountry(null, country, true);
            if (!this.strema) {
                this.clearVehicleIdentification(country);
            } else {
                this.$emit("on-plate-cleared");
            }
        },
        loadVehiclePhoto(response) {
            let vehiclePhotoParam = "Image Not Found";
            if (response.data.result.vehicleIdentification) {
                let findPhoto =
                    response.data.result.vehicleIdentification.filter(
                        (item) => item.description == "VehiclePhoto"
                    );
                if (findPhoto && findPhoto.length > 0) {
                    if (
                        findPhoto[0].value !== "" &&
                        findPhoto[0].value !== null &&
                        findPhoto[0].value !== undefined
                    ) {
                        vehiclePhotoParam = findPhoto[0].value;
                    }
                }
            }
            return vehiclePhotoParam;
        },
        clearVehicleIdentification(country = "") {
            let vehicleIdentification = {
                typeSearch: "",
                plateNumber: "",
                data: {},
                processNumber: "",
                vehiclePhoto: "Image Not Found",
                dataSourceId: country,
                carNotes: undefined,
            };
            this.$store.commit(
                "vehicleIdentification/setVehicleIdentification",
                vehicleIdentification
            );
        },
        async verifyRouteName() {
            const searchString = "/tech-info";
            const pathString = this.$route.fullPath;
            if (pathString.includes(searchString)) {
                this.$router.push("/tech-info");
            }
        },
        async handleWithNotes(result, processNumber) {
            let notes = result.map((item) =>
                Object.assign(item, {
                    seeMore: false,
                })
            );

            const today = new Date();
            const updatedNotes = notes.map((note) => {
                const validToDate = new Date(note.validTo);
                const isValid = validToDate > today;
                return { ...note, isValid };
            });

            const hasValidNotes = updatedNotes.some((note) => note.isValid);
            const sortedNotes = updatedNotes.sort(
                (a, b) => new Date(b.validFrom) - new Date(a.validFrom)
            );

            const payload = {
                processNumber: processNumber,
                notes: sortedNotes,
                hasNotes: true,
                hasValidNotes: hasValidNotes,
            };

            this.$store.commit(
                "vehicleIdentification/setVehicleIdentificationNotes",
                payload
            );
        },
        async onClickNotesIcon() {
            if (this.carNotes.hasValidNotes) {
                this.modalNotes.show = true;
            } else {
                this.onSeeNotesClicked();
            }
        },
        onPlateCleared() {
            let show = this.showQuotationModal(3);
            if (show) return;

            if (this.strema) {
                this.plate = "";
                this.$emit("on-plate-cleared");
            } else {
                this.clearPlate();
            }
        },
        async forceResolveVehicle() {
            let vehicleState = await this.$store.getters[
                "vehicleIdentification/getState"
            ];
            if (vehicleState.plateNumber) {
                this.resolvePlate(vehicleState.plateNumber);
            } else {
                this.carInfo = {
                    dataSourceId: undefined,
                    processNumber: vehicleState.processNumber,
                    make: this.$helpers.getVehicleAttributeValue(
                        this.$globals.ATTRIB_ID.MAKE
                    ),
                    model: this.$helpers.getVehicleAttributeValue(
                        this.$globals.ATTRIB_ID.MODEL
                    ),
                    bodyGroup: this.$helpers.getVehicleAttributeValue(
                        this.$globals.ATTRIB_ID.BODY_GROUP
                    ),
                    fuelType: this.$helpers.getVehicleAttributeValue(
                        this.$globals.ATTRIB_ID.FUEL_TYPE
                    ),
                    version: this.$helpers.getVehicleAttributeValue(
                        this.$globals.ATTRIB_ID.VERSION
                    ),
                    kType: this.$helpers.getVehicleAttributeValue(
                        this.$globals.ATTRIB_ID.VEHICLE_ID
                    ),
                    manualPlate: vehicleState.manualPlate,
                    plate: "",
                };
                this.resolveNoPlate();
            }
        },
    },
    created() {
        //this.updatePlateCountry();

        let dataSources = this.$store.getters["auth/getState"].dataSources;
        let state = this.$store.getters["vehicleIdentification/getState"];
        if (!this.strema) {
            this.plate = state.plateNumber;
        }
        this.countrySelected =
            state.dataSourceId ||
            (dataSources && dataSources.length > 0
                ? dataSources[0].value
                : "1");

        this.permissions = this.$store.getters["auth/getState"].modules.find(
            (o) => o.moduleId == this.$globals.MODULES.TECHNICAL_INFORMATION.ID
        ).underSubModules;
    },
    mounted() {
        /**
         * Valida inicalmente se o localStorage não exite registro
         * de matricula pesquisada.
         * O localStorage tem prioridade na recuperação do último
         * veículo pesquisado.
         *
         * Obs: A pesquisa pelo localStorage que do qual tem prioridade
         * está sendo realizada no arquivo app.js (arquivo raiz do js).
         */
        if (_.isEmpty(localStorage.getItem("lastVehicle"))) {
            if (!this.$store.getters["auth/getState"].isB2B) {
                if (
                    !_.isEmpty(this.$store.getters["auth/getState"].plate) ||
                    !_.isEmpty(
                        this.$store.getters["auth/getState"].searchManual
                    )
                ) {
                    if (this.$store.getters["auth/getState"].isSearchManual) {
                        let searchManual = JSON.parse(
                            this.$store.getters["auth/getState"].searchManual
                        );
                        let vehicleIdentification = {
                            typeSearch: "searchByManual",
                            plateNumber: "",
                            data: searchManual.data,
                            processNumber: searchManual.processNumber,
                            vehiclePhoto: searchManual.vehiclePhoto,
                            token: searchManual.token,
                        };

                        this.$store.commit(
                            "vehicleIdentification/setVehicleIdentification",
                            vehicleIdentification
                        );
                    } else {
                        this.resolvePlate(
                            this.$store.getters["auth/getState"].plate
                        );
                    }
                }
            }
        }
        if (this.$store.getters["vehicleIdentification/getState"].token) {
            let lastVehicle = JSON.parse(localStorage.getItem("lastVehicle"));
            let pickNotes = lastVehicle.carNotes;
            this.modalNotes.notes = pickNotes?.notes;
            this.modalNotes.hasNotes = pickNotes?.hasNotes;
            this.modalNotes.hasValidNotes = pickNotes?.hasValidNotes;

            if (pickNotes?.hasValidNotes && pickNotes.hasValidNotes == true) {
                this.modalNotes.notes = pickNotes.notes.filter(
                    (note) => note.isValid
                );
            }
        }

        if (this.$store.getters["auth/getState"].dataSources) {
            this.countriesPlate =
                this.$store.getters["auth/getState"].dataSources;
            if (this.countriesPlate.length == 1) {
                this.countrySelected = String(this.countriesPlate[0].value);
            }
        }

        if (
            this.$store.getters["vehicleIdentification/getState"].plateNumber &&
            this.$store.getters["vehicleIdentification/getState"].plateNumber
                .length > 6
        ) {
            if (
                this.$store.getters["vehicleIdentification/getState"]
                    .dataSourceId
            ) {
                this.countrySelected =
                    this.$store.getters[
                        "vehicleIdentification/getState"
                    ].dataSourceId;
            } else {
                this.countrySelected = "1";
            }
        }
    },
};
